/* eslint-env browser */
export const captureAdParams = (search) => {
    const STORAGE_KEY = 'ad_params';
    const PARAM_KEYS = [
        'gclid', //Google Ads params: Google Click Identifier
        'gbraid', //Google Ads params: Used in campaigns where users have iOS 14+ (for privacy)
        'wbraid', //Google Ads params: Used in campaigns where users have iOS 14+ (for privacy)
        'gclsrc', //Google Ads params: click source (ej aw.ds for Google Ads, ds for Display)
        'utm_source', //Google Ads params: UTM source
        'utm_medium', //Google Ads params: UTM medium
        'utm_campaign', //Google Ads params: UTM campaign
        'utm_term', //Google Ads params: UTM term
        'utm_content', //Google Ads params: UTM content
    ];

    if (!search || typeof search !== 'string') {
        return null;
    }

    const query = search.startsWith('?') ? search.slice(1) : search;
    const params = {};
    query.split('&').forEach((pair) => {
        const [key, value] = pair.split('=');
        if (key && value) {
            params[key] = decodeURIComponent(value);
        }
    });
    const found = {};
    PARAM_KEYS.forEach((k) => {
        const v = params[k];
        if (v) found[k] = v;
    });
    if (Object.keys(found).length > 0) {
        //Hay params
        found._ts = Date.now();
        if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(found));
        }
    }

    return null;
};
